import { useDeleteDepartment } from "./api/deleteDepartment";
import { Button } from "reactstrap";


const DeleteDepartment = ({handleCloseModal, departmentId}: DeleteDepartmentProps)  => {
  
  const deleteDepartmentMutation = useDeleteDepartment({ departmentId});
  const handleSubmit = async (): Promise<void> => {
    deleteDepartmentMutation.mutateAsync({ 
      departmentId: departmentId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Διεύθυνση;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteDepartmentProps{
  departmentId: number;
  handleCloseModal: () => void;
}

export default DeleteDepartment;